export default __webpack_public_path__ + "media/share.c051fc3b.svg";